import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { appendToRmaApiUrl } from '@rma/generic/ng/util';
import { Observable } from 'rxjs';
import { ProfileMemberInviteDetails } from '../domain/model/member-invitation.model';
@Injectable({
  providedIn: 'root',
})
export class MemberInvitationService {
  private readonly httpClient = inject(HttpClient);
  private readonly rmaApiUrl = inject(appendToRmaApiUrl);

  public acceptInvite(
    activationToken: string,
    acceptTermsAndConditions: boolean,
  ): Observable<{ userToken: string; loggedInAsInvited: boolean }> {
    const url = this.rmaApiUrl(`Member/Invite/${activationToken}`);
    return this.httpClient.post<{
      userToken: string;
      loggedInAsInvited: boolean;
    }>(url, { acceptTermsAndConditions });
  }

  public getDetailsFromToken(activationToken: string): Observable<ProfileMemberInviteDetails> {
    const url = this.rmaApiUrl(`Member/Invite/${activationToken}`);
    return this.httpClient.get<ProfileMemberInviteDetails>(url);
  }
}
